// AUTO-GENERATED by scripts/gen-version.js at build time — do not edit by hand.
export const APP_VERSION = "0.9.0";
export const BUILD_ID = "ts-mvl19tgc";
export const BUILD_DATE = "2026-10-23 13:56 UTC";
